module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Evionnaz-2ea0915faae4caed0099200301a7b645.png";